module.exports = __webpack_public_path__ + "img/HA1506-76.689a2307.jpg";